import React, { useState } from 'react';
import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';
import Table from "react-bootstrap/Table";
// import Form from "react-bootstrap/Form";
import DeleteModal from '../DeleteModal';
import ScrollingTab from '../ScrollingTab';
import { formatDate, formatDateAsItIs } from '../../helper/common';

function PostedActivity({ latestActivity, latestEvent }) {


  const [activeTab, setActiveTab] = useState("newPosted");


  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  // const handleShow = () => setShow(true);



  return (
    <>
      <div className="card-wrapper">
        <div className="card-body">
          <Tab.Container id="dashboardTab" activeKey={activeTab} onSelect={(key) => setActiveTab(key)}>
            <ScrollingTab>
              <Nav className='theme-tab'>
                <Nav.Item>
                  <Nav.Link eventKey="newPosted">Rectly New Post</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="flaggedActivity">Recently New Event</Nav.Link>
                </Nav.Item>
              </Nav>
            </ScrollingTab>
            <Tab.Content className='mt-3'>
              <Tab.Pane eventKey="newPosted">
                <div className="overflow-x-auto theme-scrollbar">
                  <Table className="theme-table">
                    <thead>
                      <tr>
                        <th>Username</th>
                        <th>Post Title</th>
                        <th>Time Posted</th>
                        <th>Likes</th>
                        <th>Comments</th>
                        {/* <th>Make It</th> */}
                        {/* <th>Action</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {latestActivity?.map((post, index) => (
                        <tr key={index}>
                          <td>{post?.userId?.firstName + " " + post?.userId?.lastName || '-'}</td>
                          <td style={{ minWidth: "200px" }}>{post?.des || "-"}</td>
                          <td>{formatDateAsItIs(post?.createdAt)}</td>
                          <td>{post?.like?.length || 0}</td>
                          <td>{post?.commentId?.length || 0}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </Tab.Pane>
              <Tab.Pane eventKey="flaggedActivity">
                <div className="overflow-x-auto theme-scrollbar">
                  <Table className="theme-table">
                    <thead>
                      <tr>
                        <th>Username</th>
                        <th>Post Title</th>
                        <th>Event Date & Time</th>
                        <th>Activities</th>
                        <th>Skills</th>
                        {/* <th>Flagged Reason</th> */}
                        {/* <th>Status</th> */}
                        {/* <th>Action</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {Boolean(latestEvent?.length) ? latestEvent?.map((post, index) => (
                        <tr key={index}>
                          <td>{post?.userId?.firstName + " " + post?.userId?.lastName || '-'}</td>
                          <td style={{ minWidth: "200px" }}>{post?.eventName}</td>
                          <td>{formatDate(post?.eventDate)}</td>
                          <td className='text-capitalize'>{post?.activities.map((activity) => activity?.title).join(", ") || '-'}</td>
                          <td className='text-capitalize' >{post?.skill.map((skill) => skill?.name).join(", ") || '-'}</td>
                          {/* <td>{row.flaggedReason}</td> */}
                          {/* <td>
                            <ul className="table-status">
                              <li className={row.status === 'Pending' ? 'status-danger' : 'status-success'}>
                                {row.status}
                              </li>
                            </ul>
                          </td> */}
                          {/* <td width={220}>
                            {row.status === 'Pending' && (
                              <div className="d-flex align-items-center gap-2">
                                <button
                                  className={`btn btn-light-danger ${selectedActions[row.id] === 'reject' ? 'active' : ''}`}
                                  onClick={() => handleButtonClick(row.id, 'reject')}
                                >
                                  Reject
                                </button>
                                <button
                                  className={`btn btn-light-success ${selectedActions[row.id] === 'approve' ? 'active' : ''}`}
                                  onClick={() => handleButtonClick(row.id, 'approve')}
                                >
                                  Approve
                                </button>
                              </div>
                            )}
                          </td> */}
                        </tr>
                      )) : (
                        <tr>
                          <td colSpan={10} className='text-center p-5 fs-5'>
                            No Records Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </div>
      </div>
      <DeleteModal show={show} handleClose={handleClose} />
    </>
  )
}

export default PostedActivity